/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/itemgrideditor.ts" />
namespace TabAurous.Inventory {

    import fld = StockAllocationItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class StockAllocationItemsEditor extends _Ext.ItemGridEditor<StockAllocationItemsRow> {
        protected getColumnsKey() { return "Inventory.StockAllocationItems"; }
        protected getDialogType() { return StockAllocationItemsDialog; }
        protected getLocalTextPrefix() { return StockAllocationItemsRow.localTextPrefix; }
        protected form: StockAllocationItemsForm;

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = false;
            return opt;
        }

        private pendingChanges: Q.Dictionary<any> = {};

        public PartyId: number = 0;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public DeptId: number;
        private GenSKU: boolean = false;
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public MasterEntity: any;
        isEditable: boolean;
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: false, rowHeight: 30 });


            this.isEditable = this.slickGrid.getOptions().editable;



        }
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);

            var curr = new TabAurous.OMS.CurrencyFormatter;

            curr.currencyName = 'INR';

            columns.push(
                {
                    field: 'Allocate1',
                    name: 'Allocate Stock',
                    format: ctx => '<a class="inline-action add-button allocate-stock" href="#"><span></span>Allocate</a>',
                    width: 90,
                    minWidth: 90,
                    maxWidth: 90
                });
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            return columns;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            var x = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(x.row);
            var id = this.id(this.itemAt(x.row));
            var target = $(e.target);
            var self = this;
            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();
                if (target.hasClass('delete-row')) {
                    if (this.isReadOnly) {
                        q.Alert("View Mode", "Can not make changes in view mode", 2000, true);
                    }
                    else {
                        //TODO: Validate for TransItemID in RefTransItemID in Stock
                        q.information('Are you sure want to Delete?', '', true, () => {

                            this.view.deleteItem(id);

                        }, () => { });
                    }
                    this.view.refresh();
                }


                if (target.hasClass('allocate-stock')) {
                    var filters: _Ext.SelectGridFilters = {
                        ProductId: item.ProductId,
                        AttributeId: item.AttributeId
                    }

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: Common.StockAllocateGrid, multiple: true, title: "Select Stock Items",
                        GridFilters: filters, preSelectedKeys: this.value.map(k => k.ProductId)
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId && n.Line_No == t.Line_No) });
                        var pcs = 0, wt = 0;
                        for (let Itemdetail of selectedItems2) {
                            pcs += Itemdetail.Pieces;
                            wt += Itemdetail.Weight;
                            //Itemdetail.Line_No = Itemdetail.LineNo;

                            var newitem = this.setData(Itemdetail);
                            newitem.DepartmentId = Itemdetail.DepartmentId;
                            newitem.RefVoucherId = Itemdetail.RefVoucherId;
                            newitem.RefTransId = Itemdetail.RefTransId;
                            newitem.RefTransItemId = Itemdetail.RefTransItemId;
                            // this.form.setDat(this.view.getItems(), this.view.getItems().length); 
                            item.DepartmentId = Itemdetail.DepartmentId;
                            item.AllocatedItems.push(newitem);

                        }
                        item.AllocatedPieces = pcs;
                        item.AllocatedWeight = wt;
                        this.view.updateItem(id, item);
                    }
                    pickerDialog.dialogOpen();
                }



                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }


        public Editable() {
            this.isEditable = true;
        }


        // **** to Call shortcut key in Main Window
        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }

        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }


            this.view.updateItem(id, item);

            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            //**** Master ****//

            //**** POS Order ****//
            buttons.push({
                title: "Select POSOrders",
                cssClass: "order-button",
                hotkey: "alt+p",
                hint: 'alt+p',
                onClick: () => {
                    var grid = Common.POSOrderItemsForStockAllocation;
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;
                    }
                    else {

                        var filters: _Ext.SelectGridFilters = {

                            InStock: false
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetLocationTransferItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        for (let Item of ItemDetails) {
                            var newitem = this.setData(Item);
                            newitem.AllocatedItems = [];
                            newitem[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(newitem);
                        }
                    }

                    pickerDialog.dialogOpen();
                }
            });



            //**** Sales Order ****//
            buttons.push({
                title: "Select SO",
                cssClass: "order-button",
                hotkey: "alt+i",
                hint: 'alt+i',
                onClick: () => {
                    var grid = Common.OrderForStockAllocationSelectGrid;
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {

                        var filters: _Ext.SelectGridFilters = {
                            PartyId: this.PartyId,
                            InStock: false
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetLocationTransferItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);

                        for (let Item of ItemDetails) {
                            var newitem = this.setData(Item);
                            newitem.AllocatedItems = [];
                            newitem.AllocatedPieces = 0;
                            newitem.AllocatedWeight = 0;
                            newitem.DepartmentId = Item.DepartmentId;

                            newitem.RefVoucherId = Item.RefVoucherId;
                            newitem.RefTransId = Item.RefTransId;
                            newitem.RefTransItemId = Item.RefTransItemId;
                            newitem[this.getIdProperty()] = "`" + this.nextId++;

                            this.view.addItem(newitem);
                        }

                    }
                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
        setData(Item: any) {
            var bomdetails = [];
            for (var i = 0; i < Item.BOMDetails.length; i++) {
                var oldbom: Stock.StockItemBOMRow = Item.BOMDetails[i];
                var newbom: StockAllocationItemsBOMRow = {
                    BOMAttributeId: oldbom.BOMAttributeId,
                    BomAmount: oldbom.BomAmount,
                    BomRate: oldbom.BomRate,
                    CalcOnId: oldbom.CalcOnId,
                    CertificateNo: oldbom.CertificateNo,
                    ItemTypeId: oldbom.ItemTypeId,
                    Pieces: oldbom.Pieces,
                    Weight: oldbom.Weight,
                    PureWeight: oldbom.PureWeight,
                    Purity: oldbom.Purity,
                    BOMProductId: oldbom.BOMProductId,
                    ProductId: oldbom.ProductId,
                    Lab: oldbom.Lab,
                    RefTransBomId: oldbom.StockBomId,
                    StoneStatusId: oldbom.StoneStatusId,
                    Discount: 0,
                    DiscountPercent: 0,
                }
                bomdetails.push(newbom);
            }
            var newitem: StockAllocationItemsRow = {

                ProductId: Item.ProductId,
                AttributeId: Item.AttributeId,
                Attribute: Item.Attribute,
                Line_No: Item.Line_No == null ? Item.LineNo : Item.Line_No,
                DepartmentId: Item.DepartmentId,
                SKU: Item.SKU,
                ProductCode: Item.ProductCode,
                ProductName: Item.ProductName,
                ItemTypeId: Item.ItemTypeId,
                HasBom: Item.HasBom,
                CategoryId: Item.CategoryId,
                ProductTypeId: Item.ProductTypeId,
                SubCategoryId: Item.SubCategoryId,
                BrandId: Item.BrandId,
                SuperTypeId: Item.SuperTypeId,
                CollectionId: Item.CollectionId,
                Pieces: Item.Pieces >= 0 ? Item.Pieces : 0,
                Weight: Item.Weight,
                OtherPieces: Item.OtherPieces,
                OtherWeight: Item.OtherWeight,
                StonePieces: Item.StonePieces,
                StoneWeight: Item.StoneWeight,
                NetWeight: Item.NetWeight,
                DiamondPieces: Item.DiamondPieces,
                DiamondWeight: Item.DiamondWeight,
                CalcOnId: Item.CalcOnId,
                BOMDetails: bomdetails,
                // LaborDetails: labordetail,
                CompanyId: Item.CompanyId,
                HSN: Item.HSN,
                TaxCode: Item.TaxCode,
                MetalId: Item.MetalId,
                KaratId: Item.ItemTypeId == 101 ? Item.KaratId : Item.KaratId,
                MetalColorId: Item.MetalColorId,
                QualityId: Item.QualityId,
                SieveId: Item.SieveId,
                ShapeId: Item.ShapeId,
                StoneColorId: Item.StoneColorId,
                StoneSizeId: Item.StoneSizeId,
                ImageName: Item.ImageName,
                Studded: Item.Studded, // marking item as bulk
                StoneCutId: Item.StoneCutId,
                StonePolishId: Item.StonePolishId,
                StoneSymmetryId: Item.StoneSymmetryId,
                StoneFluorescenceId: Item.StoneFluorescenceId,
                StoneCuletId: Item.StoneCuletId,
                StoneGirdleId: Item.StoneGirdleId,
                StoneTable: Item.StoneTable,
                StoneDepth: Item.StoneDepth,
                Lab: Item.Lab,
                CertificateNo: Item.CertificateNo,
                Purity: Item.Purity,
                CalcUnitId: Item.CalcUnitId,
                LotNo: Item.LotNo,
                PureWeight: Item.Weight * Item.Purity,
                BagNo: Item.BagNo,
                Hallmark: Item.Hallmark,
                RefVoucherId: Item.RefVoucherId,
                RefTransId: Item.RefTransId,
                RefTransItemId: Item.RefTransItemId,
                StockAllocation: Item.StockAllocation
            }
            return newitem;
        }

    }
}